import { useQuery } from "@tanstack/react-query"
import { getEmployeeListByProject } from "../store/actions/MissionsActions"
import { AllEmployeeTypes, EmployeeType } from "../store/types/MissionsTypes"
import { API, NexusSuccessResponse } from "./API"
import { QueryKeys } from "./QueryConfig"

export const useFindEmployeeListByProject = (projectNumber: string) => {
    return useQuery({
        queryKey: [QueryKeys.FIND_EMPLOYEE_LIST_BY_PROJECT, projectNumber],
        queryFn: async (): Promise<AllEmployeeTypes> => {
            const result = await getEmployeeListByProject(projectNumber)
            return result.data
        },
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    })
}

export const useFindEmployeeList = () => {
    return useQuery({
        queryKey: [QueryKeys.FIND_EMPLOYEE_LIST],
        queryFn: async () => {
            const result: NexusSuccessResponse<EmployeeType[]> = await API.get(
                "/employees",
                "Could not load employees.",
            )
            return result.data
        },
    })
}
